import React, { useEffect } from 'react';
import '../../CSS/HomeClassModel.css';
import {getConvertedTime} from '../../Functions.js';

function ClassModel(props){
    var classDetails = props.classDetails;
    var heading = props.heading;
    var classStatus = props.classStatus;
    var noClassMessage = props.noClassMessage;
    return(
        <div className="ClassDiv">
            <div className="ClassHeadingDiv">
                {heading}
            </div>
            
            {classStatus===false?
            <div className="NoClassDiv">
                {noClassMessage}
            </div>:
            
            <div className="ClassModelDiv">
                <div className="Title">
                    {classDetails.title}
                </div>
                <div className="Faculty">
                    {classDetails.FacultyName}
                </div>
                <div className="Interval">
                    <div className="Start">
                        {getConvertedTime(classDetails.start)}
                    </div>
                    <div className="End">
                        {getConvertedTime(classDetails.end)}
                    </div>
                </div>
            </div>
            }
        </div>
    );

}

export default ClassModel;